import { useRef } from "react";

import useIframeHeightReset from "../hooks/useIframeHeightReset";

const Iframe = ({ iframeURL, customization }) => {
  const { height, width, iframeTitle, dynamicHeight } = customization;

  const iframeRef = useRef(null);
  useIframeHeightReset(iframeRef, dynamicHeight);

  return (
    <iframe
      {...{ height, width }}
      allowFullScreen
      className="m-auto border-0"
      ref={iframeRef}
      src={iframeURL}
      title={iframeTitle}
    />
  );
};

export default Iframe;
